import React from "react";

export default function TitleBar({ title }: { title: string[] }) {
  console.log("Title:", title);
  return (
    <div className="d-flex position-relative w-100 align-items-center justify-content-between py-4 px-5 fs-5">
      <div className="d-flex items-center gap-2 fs-6 text-secondary">
        {title.map((t, i) => (
          <React.Fragment key={i}>
            {i > 0 && <i className="bi bi-chevron-right"></i>}
            <span
              className={
                i === title.length - 1
                  ? "text-dark font-normal"
                  : ""
              }
            >
              {t}
            </span>
          </React.Fragment>
        ))}
      </div>
      <div className="d-flex gap-3">
        <button
          className="d-flex align-items-center gap-2 px-4 py-2 text-secondary bg-white border border-secondary-subtle rounded-3 fw-medium"
          style={{ fontSize: "0.875rem" }  }
        >
          <i className="bi bi-file-pdf fs-6" /> Export PDF
        </button>
        <button
          className="d-flex align-items-center gap-2 px-4 py-2 text-secondary bg-white border border-secondary-subtle rounded-3 fw-medium"
          style={{ fontSize: "0.875rem" }  }
        >
          <i className="bi bi-printer fs-6" /> Print
        </button>
      </div>
    </div>
  )
}